<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-contact-reasons-detail-topic-entities" v-loading="loading">
    <div class="entities-found-section">
      <div class="div-entities-found-header" v-bind:class="{'without-border': entitiesFoundList&&entitiesFoundList.length==0}">
        <div>Entities found in topic</div>
      </div>    
      <div class="no-entity-msg" v-if="entitiesFoundList.length==0">0 entities found</div>  
      <el-table
        :data="entitiesFoundList"
        ref="entitiesFoundListTable"
        border
        class="entities-found-table">
        <el-table-column
          v-if="entitiesFoundList.length>0"
          show-overflow-tooltip
          prop="entity"
          sortable
          label="Entity"
          width="450">
        </el-table-column>
        <el-table-column
          v-if="entitiesFoundList.length>0"
          prop="category"
          sortable
          show-overflow-tooltip
          label="Category"
          width="450">
        </el-table-column>
        <el-table-column
          v-if="entitiesFoundList.length>0"
          prop="count"
          label="Total"
          sortable
          width="200"
          label-class-name="col-label-total"
          class-name="col-total">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import WyUtils from '../../library/wy-utils.js';

export default Vue.extend({
  name: 'wy-analytics-contact-reasons-detail-topic-entities',
  props: ['parent', 'activeTab'],

  data() {
    return {
      module: this,
      loading: false,
      initDate: null,
      entitiesFoundList: [],
      topicData: {},
      fetchData: true
    }
  },

  computed: {
    ...mapGetters(['dataModel']),
  },

  methods: {
    ...mapActions(['fetchContactReasonsTopicEntities']),

    startLoading() {
      this.initDate = new Date();
      if(!this.loading) {
        this.logEventLoaded();
      }
      this.loadTopicEntities();
    },

    logEventLoaded() {
      if(this.initDate) {
        this.$store.dispatch('amplitudeLogWithFilters', {name: 'entities_loaded', data: {topic_name: this.topicData.topicDisplayName, data_load_time: WyUtils.getTimeDiff(this.initDate)}});
        this.initDate = null;
      }
    },
    
    generateEntitiesList(dataList) {
      let listData = [];
      dataList.forEach(item=>{
        let arr = item.split("::");
        let obj={
          entity: arr[0],
          category: arr[1],
          count: (arr[2] * this.$store.getters.xnumber)
        }
        listData.push(obj)
      })
      return listData;
    },

    async loadTopicEntities() {
      if(this.fetchData && this.parent.currentItem) {
        this.fetchData = false;
        this.topicData = this.parent.currentItem;
        this.loading = true;
        let result = await this.fetchContactReasonsTopicEntities({topics: this.parent.currentItem.mergedTopics, topicDisplayName: this.parent.currentItem.topicDisplayName});
        if(result.data && result.data.entities) {
          this.responseMessageList = result.data.messages;
          this.entitiesFoundList = [];
          this.entitiesFoundList = this.generateEntitiesList(result.data.entities);    
        }
        else {
          document.querySelector(".entities-found-table .el-table__header-wrapper").style["border-bottom"] = "0"
        }
        this.loading = false;
      }
      this.parent.stopLoadingByTab('entities');      
    }
  },

  // async created() {
  //   this.loadTopicEntities();
  // },
});
</script>

<style lang="scss">
.wy-analytics-contact-reasons-detail-topic-entities {
  display: inline-flex;
  width: 100%;
  height: calc(100vh - 262px);

  .el-table .descending .sort-caret.descending {
    border-top-color: var(--site-font-primary-color) !important;
  }
  .el-table .ascending .sort-caret.ascending {
    border-bottom-color: var(--site-font-primary-color) !important;
  }
  .el-table--border, .el-table--group {
    border: 0px;
  }

  .customer-messages-section {
    min-width: 500px;
    width: 45%;
    display: inline-block;

    .div-customer-messages-header {
      padding: 20px 0 10px 33px;
      font-size: 14px;
      font-weight: 600;  
      border-right: 1px #F1F2F2 solid;    
    }
    .div-customer-messages-footer {
      padding: 7px 0 7px 33px;
      font-size: 12px;
      color: #CBCBCB;
    }
    .el-table--border, .el-table--group {
      border: 0px;
    }

    .response-messages-table {
      height: calc(100vh - 300px);
      background: #FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 0px 1px 2px #0000000f;
      opacity: 1;
      min-width: 500px;
      padding: 0px 0px 0px 0px;
      margin: 0px 0px 0px 0px;
      color: var(--site-font-primary-color);
      font-size: 12px;

      th, td {
        border: 0px;
        border-bottom: 0px solid #EBEEF5 !important;
        padding: 5px 0px;
        color: var(--site-font-primary-color);
      }
      th, tr {
        // background-color: #FCFEFF;
        .cell {
          padding-left: 0px;
          padding-right: 0px;
          // max-width: 135px;
          line-height: unset;
          word-break: break-word;
          font-weight: 500;
        }
      }
      th:first-child, td:first-child {
        .cell {
          padding-left: 34px;
        }
      }
      .el-table__header-wrapper {
        border-bottom: 1px solid #F1F2F2;
        min-width: 500px;
      }
      .el-table__body-wrapper {
        min-width: 500px;
        overflow-x: hidden;
        overflow-y: auto;
        height: 100%;
      }
      .el-table__body tr.el-table__row--striped td {
        background-color: #FFFFFF;
      }
      // .even-row{
      //   background-color: #FFFFFF;
      // }
      // .odd-row{
      //   background-color: #FCFEFF;
      // }
      .view-transcript{
        width: 30px;
        height: 26px;
        margin-left: 35px;
        cursor: pointer;
        background-repeat: no-repeat;
        background-size: 64%;
        background-image: url('../../assets/images/analytics/read-transcript.svg');
        background-position-y: 6px;
      }
    }
  }

  .entities-found-section {
    min-width: 332px;
    width: 1100px;
    display: inline-block;
    border-left: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
    margin-left: 25px;
    margin-top: 25px;
    margin-bottom: 20px;
    border-radius: 10px;
    

    .div-entities-found-header {
      padding: 20px 0 10px 33px;
      // border-bottom: 1px solid #F1F2F2;
      font-size: 14px;
      font-weight: 600;
      border-right: 1px #F1F2F2 solid;
      border-top-right-radius: 10px;
      .desc {
        font-weight: normal;
        margin-top: 15px;
      }
    }
    .div-entities-found-header.without-border {
      border-bottom: 0px solid #F1F2F2;
    }
    // .el-table__header-wrapper {
    //   height: 0px;
    // }
    .el-table__body-wrapper {
      position: sticky !important;
      overflow-y: auto !important;
      height: calc(100vh - 405px) !important;
    }
    .el-table--border, .el-table--group {
      border: 0px;
    }
    .entities-found-table::before {
      background-color: transparent !important;
    }
    .entities-found-table {
      height: calc(100vh - 353px);
      background:#FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 0px 1px 2px #0000000f;
      opacity: 1;
      // min-width: 281px;
      width: 1100px;
      padding: 0px 0px 0px 0px;
      margin: 0px 0px 0px 0px;
      color: var(--site-font-primary-color);
      font-size: 12px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;

      .el-table {
        font-size: 12px;
      }
      th, td {
        border: 0px;
        border-bottom: 0px solid #EBEEF5 !important;
        padding: 8px 0px 8px 0px;
        // color: #545454;
        color: var(--site-font-primary-color);
      }
      th, tr {
        // background-color: #FCFEFF;
        .cell {
          padding-left: 34px;
          // width: 135px;
          line-height: unset;
          cursor: default;
          // word-break: break-word;
        }
      }
      .el-table__header-wrapper {
        border-bottom: 1px solid #F1F2F2;
      }
      .col-label-total div.cell{
        text-align: right;
        padding-right: 100px;
      }
      .col-total div.cell{
        text-align: center;
        padding-right: 100px;
      }
      .el-table__body tr.el-table__row--striped td {
        background-color: #FFFFFF;
      }
      // .even-row{
      //   background-color: #FFFFFF;
      // }
      // .odd-row{
      //   background-color: #FCFEFF;
      // }

      .el-table__empty-block {
        display: none;
        height: 288px !important;
        width: 100% !important;
        .no-data {
          text-align: center;
          display: block;
          border: none;
          height: 83px;
          // width: 100%;
          margin-top: 0px;
          background-position-x: 0px;
          background-repeat: no-repeat;
          background-size: 165px 73px;
          background-image: url('../../assets/icons/icon_entities.svg');
        }
        .no-data-title {
          width: 160px;
          // margin-left: 11%;
          margin-top: 0px;
          text-align: center;
          font-size: 12px;
          color: var(--site-font-primary-color) !important;
          font-weight: 500;
        }
        .no-data-content-first-row {
          width: 160px;
          line-height: 20px;
          color: var(--site-font-primary-color) !important;
        }
        .no-data-content-second-row {
          width: 160px;
          line-height: 20px;
          padding-top: 13px;
          color: var(--site-font-primary-color) !important;
        }
      }
    }

    .no-entity-msg {
      padding-left: 33px;
      font-size: 15px;
      font-weight: 500;
      border-right: 1px #F1F2F2 solid;
      padding-bottom: 5px;
    }
  }

  .top-keywords-found-section {
    width: 25%;
    display: inline-block;
    border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;

    .div-top-keywords-found-header {
      padding: 20px 0 10px 33px;
      font-size: 14px;
      font-weight: 600;
    }
    .el-table__header-wrapper {
      height: 0px;
    }
    .el-table__body-wrapper {
      overflow-x: hidden;
      overflow-y: auto;
      height: 460px;
      // margin-bottom: 10px;
    }
    .el-table--border, .el-table--group {
      border: 0px;
    }

    .top-keywords-found-table {
      height: calc(100vh - 270px);
      background: #FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 0px 1px 2px #0000000f;
      opacity: 1;
      min-width: 257px !important;
      padding: 0px 0px 0px 0px;
      margin: 0px 0px 0px 0px;
      font-size: 12px;

      .el-table {
        font-size: 12px;
        color: var(--site-font-primary-color);
      }
      th, td {
        border: 0px;
        border-bottom: 0px solid #EBEEF5 !important;
        padding: 5px 0px;
        // color: #545454;
        color: var(--site-font-primary-color);
      }
      th, tr {
        // background-color: #FCFEFF;
        .cell {
          padding-left: 34px;
          max-width: 135px;
          line-height: unset;
          word-break: break-word;
          cursor: default;
        }
      }
      .el-table__body-wrapper {
        height: 100%;
      }
      .el-table__header-wrapper {
        border-bottom: 0px solid #F1F2F2;
      }
      .el-table__body tr.el-table__row--striped td {
        background-color: #FFFFFF;
      }
      // .even-row{
      //   background-color: #FFFFFF;
      // }
      // .odd-row{
      //   background-color: #FCFEFF;
      // }
    }

    .top-keywords-found-table::before {
      background-color: transparent;
    }
  }
}
.topic-no-message-content {
  color: var(--site-font-primary-color);
  background-color: #FFFF;
  margin-bottom: 3px;
  height: calc(100vh - 326px);

  .no-data {
    text-align: center;
    display: block;
    border: none;
    // height: 130px;
    height: 126px;
    margin-top: 100px;
    background-position-x: 50%;
    background-repeat: no-repeat;
    background-size: 116px;
    background-image: url('../../assets/icons/icon_no_data.svg');
  }
  .no-data-title {
    width: 100%;
    margin-top: 0px;
    text-align: center;
    font-size: 20px;
    color: var(--site-font-primary-color) !important;
    font-weight: 600;
  }
  .no-data-content-first-row {
    width: 100%;
    text-align: center;
    color: var(--site-font-primary-color) !important;
    padding-top: 16px;
    font-size: 14px;
    font-weight: 500;
  }
  .no-data-content-second-row {
    width: 100%;
    text-align: center;
    color: var(--site-font-primary-color) !important;
    font-size: 14px;
    font-weight: 500;
  }
}



  .wy-analytics-contact-reasons-detail-transcript-modal {
    border-radius: 10px;
    border: 2px solid #214586;
    color: var(--site-font-primary-color);
    box-shadow: 0px 2px 6px #0000000A;

    .el-dialog__body {
      color: var(--site-font-primary-color);
      padding: 0px 30px;
    }
    .el-table {
      color: var(--site-font-primary-color);
      border: 1px solid #EBEEF5;
      border-radius: 10px 10px 0px 0px;
      td {
        border: 0px;
        vertical-align: top;
      }
    }
    .el-table__header-wrapper{
      display: none;
    }
    .el-table__body-wrapper {
      overflow-y: auto;
      position: relative;
      max-height: 500px;
    }
    
    .div-header {
      display: inline-flex;
    }
    .div-header-right{
      display: inline-flex;
      padding-top: 34px;

      .div-header-time-range {
        padding-right: 10px;
      }
      .div-header-date {
        padding-left: 1px;
      }
    }
    .chat-header {
      height: 73px;
      background-repeat: no-repeat;
      background-size: 8%;
      background-position: 10px 10px;
      background-image: url('../../assets/icons/chat-icon.png');
      margin-bottom: 10px;
      width: 500px;
      .chat-title {
        display: inline-block;
        color: #214586;
        font-size: 34px;
        font-weight: 400;
        height: 37px;
        padding-top: 15px;
        padding-bottom: 2px;
        padding-left: 70px;
        vertical-align: bottom;
      }
    }
    .chat-id {
      display: inline-block;
      padding-left: 72px;
    }
    .date-info{
      font-weight: bold;
      float: right;
      margin-right: 0px;
    }
    .div-time-info {
      margin: 15px 3px 10px 1px;
      font-weight: 600;
      .div-msg-start-time {
        font-size: 12px;
        display: inline-block;
      }
      .div-msg-end-time {
        font-size: 12px;
        float: right;
      }
    }
    .el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #FCFCFC;
    }
    .el-table__body tr:hover td {
      background-color: transparent;
    }
    .short-span {
      max-width: 300px;
    }
    .view-transcript-content {
      max-width: 500px;
      word-break: break-word;
      display: inline-flex;
    }
    .time {
      width: 130px;
      padding-left: 50px;
      padding-right: 15px;
      float: right;
      vertical-align: middle;
      color: #B3B3B3;
    }
    .el-dialog__header {
      padding: 0px 20px 15px;
    }
    .el-dialog__footer {
      padding: 0px 20px 25px;
    }
  }
</style>
